export enum Route {
  downloadEbook = 'Download Ebook',
  notFound = 'Not Found Page'
}
